import {observer} from 'mobx-react';
import React from 'react';
import {userStatusService} from '../../../domain';
import {ClassroomRole, ClassroomRoles} from '../../../scenes/classroom/models/classroom-models';

interface Props {
  value: ClassroomRole;
  onChange: (role: ClassroomRole) => void;
}

interface Option {
  value: ClassroomRole;
  label: string;
}

const options: readonly Option[] = [
  {
    value: 'Student',
    label: 'Student view'
  },
  {
    value: 'Teacher',
    label: 'Teacher view'
  }
];

@observer
export class ClassroomRoleSelect extends React.Component<Props> {
  onChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
    let value = event.target.value as ClassroomRole;
    if (!ClassroomRoles.includes(value))
      value = ClassroomRoles[0];
    this.props.onChange(value);
  }

  render() {
    const value = this.props.value;
    const isContentManager = userStatusService.status.roles.ContentManager;

    return isContentManager ? (
      <select className="custom-select"
              onChange={this.onChangeHandler}
              value={value}>
        {
          options.map((option, index) => {
            return (
              <option key={index}
                      value={option.value}>
                {option.label}
              </option>);
          })
        }
      </select>
    ) : null;
  }
}
